import React from 'react';
import styled from 'styled-components';
import { I18n } from 'react-redux-i18n';

import Card from 'components/Card';
import Select from 'components/Select/SelectFilter';

const OnlineSalesFiltersContainer = styled.div`
  > div {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-around;
  }
  .row {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    width: 100%;
  }

  .selectTopRow {
    flex-basis: 31%;
    margin-right: 20px;
  }

  @media (max-width: ${(props) =>
      props.theme.devices.isTablet ? '0px' : '845px'}) {
    > div {
      padding: 0;
      height: auto;
    }

    .row {
      flex-direction: column;
      align-items: center;
    }

    .row > div {
      margin-left: 20px;
      margin-top: 10px;
      min-width: 200px;
    }
  }

  .distributionFiltersContainer {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    grid-gap: 25px;
    width: 100%;

    > * {
      align-self: flex-start;
    }
    .label {
      margin-bottom: 15px;
    }
  }
`;

const OnlineSalesFilters = ({ wineFilter, marketFilter }) => (
  <OnlineSalesFiltersContainer>
    <Card>
      <div className="distributionFiltersContainer">
        <Select
          label={I18n.t('onlineSales.filters.wine')}
          placeholder={I18n.t('onlineSales.filters.winePlaceholder')}
          isClearable={false}
          {...wineFilter}
        />
        <Select
          label={I18n.t('onlineSales.filters.market')}
          name="market"
          placeholder={I18n.t('placeholderAll')}
          {...marketFilter}
        />
      </div>
    </Card>
  </OnlineSalesFiltersContainer>
);

export default OnlineSalesFilters;
